import { render, staticRenderFns } from "./TripForm.vue?vue&type=template&id=5e1f1ea8&"
import script from "./TripForm.vue?vue&type=script&lang=js&"
export * from "./TripForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports